<script setup lang="ts">
import type { SkeletonProps } from '.';

import { cn } from '@/utils';

import { skeletonVariants } from '.';

const props = withDefaults(defineProps<SkeletonProps>(), {
	isActive: false,
	onlySkeleton: false,
	variant: 'primary'
});
const activeClasses = computed(() =>
	cn(skeletonVariants({ variant: props.variant }), props.class)
);
</script>

<template>
	<template v-if="props.isActive">
		<div :class="activeClasses">
			<slot v-if="props.onlySkeleton" />
			<slot v-else name="fallback" />
		</div>
	</template>

	<template v-else>
		<Suspense v-if="$slots.fallback && !props.onlySkeleton">
			<template #default>
				<div :class="props.class">
					<slot />
				</div>
			</template>
			<template #fallback>
				<div :class="activeClasses">
					<slot name="fallback" />
				</div>
			</template>
		</Suspense>

		<div v-else :class="props.class">
			<slot />
		</div>
	</template>
</template>
